import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFullscreenExitStyle0 = gravityIconIndividualCss;

const GravityIconFullscreenExit = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '04a74e483b06c9c1b3f714d5e14e6e7c85b0b256', color: this.color, size: this.size }, h("svg", { key: '6891bfa47e2cdc5f5982840cccc141bba59cb342', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '1a856cddb7b199bb86bd24252d6ef532c70dcda9', d: "M7.5 4.5v3h-5A.5.5 0 0 0 2 8v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5Zm0 10h-5A.5.5 0 0 1 2 14v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-3Zm7 0v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5Zm0-7h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" }))));
    }
};
GravityIconFullscreenExit.style = GravityIconFullscreenExitStyle0;

export { GravityIconFullscreenExit as gravity_icon_fullscreen_exit };

//# sourceMappingURL=gravity-icon-fullscreen-exit.entry.js.map